import axiosApi, { setHeader } from "api/root.api";

export const copyProject = async (projectID, body, token) => {
  const urlEnd = `/editor/project/v1/${projectID}/copy`;
  setHeader("Authorization", `Bearer ${token}`);
  const response = await axiosApi.post(urlEnd, body);
  const result = response.data;
  return result;
};

export const transferProject = async (projectID, body, token) => {
  const urlEnd = `/editor/project/v1/${projectID}/transfer`;
  setHeader("Authorization", `Bearer ${token}`);
  const response = await axiosApi.post(urlEnd, body);
  const result = response.data;
  return result;
};
